"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PointLight_decay, _PointLight_distance, _PointLight_position;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointLight = void 0;
const gl_matrix_1 = require("gl-matrix");
const ILight_1 = require("../../interface/ILight");
const AbstractLight_1 = require("../AbstractLight");
class PointLight extends AbstractLight_1.AbstractLight {
    // #endregion Properties (3)
    // #region Constructors (1)
    constructor(properties) {
        super({
            color: properties.color || "#ffffff",
            intensity: properties.intensity !== undefined ? properties.intensity : 1,
            type: ILight_1.LIGHT_TYPE.POINT,
            name: properties.name,
            order: properties.order,
            id: properties.id,
            version: properties.version,
        });
        // #region Properties (3)
        _PointLight_decay.set(this, 0);
        _PointLight_distance.set(this, 0);
        _PointLight_position.set(this, gl_matrix_1.vec3.fromValues(0, 0, 0));
        if (properties.position)
            __classPrivateFieldSet(this, _PointLight_position, properties.position, "f");
        if (properties.distance)
            __classPrivateFieldSet(this, _PointLight_distance, properties.distance, "f");
        if (properties.decay)
            __classPrivateFieldSet(this, _PointLight_decay, properties.decay, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (6)
    get decay() {
        return __classPrivateFieldGet(this, _PointLight_decay, "f");
    }
    set decay(value) {
        __classPrivateFieldSet(this, _PointLight_decay, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    get distance() {
        return __classPrivateFieldGet(this, _PointLight_distance, "f");
    }
    set distance(value) {
        __classPrivateFieldSet(this, _PointLight_distance, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    get position() {
        return __classPrivateFieldGet(this, _PointLight_position, "f");
    }
    set position(value) {
        __classPrivateFieldSet(this, _PointLight_position, value, "f");
        this.updateVersion();
        if (this.parentNode)
            this.parentNode.updateVersion();
    }
    // #endregion Public Getters And Setters (6)
    // #region Public Methods (1)
    clone() {
        return new PointLight({
            color: this.color,
            position: this.position,
            distance: this.distance,
            decay: this.decay,
            intensity: this.intensity,
            name: this.name,
            order: this.order,
            id: this.id,
            version: this.version,
        });
    }
}
exports.PointLight = PointLight;
_PointLight_decay = new WeakMap(), _PointLight_distance = new WeakMap(), _PointLight_position = new WeakMap();
//# sourceMappingURL=PointLight.js.map